define([
    './GTMProvider',
], (GTMProvider) => {
    return angular.module('portal.app.providers', [])
        .provider('GTMProvider', GTMProvider);
});



// WEBPACK FOOTER //
// ./app/js/portal/providers/module.js